<template>
<div class="trail-reviews__review-card review-card-js-component">
  <hr class="my-3">
  <div class="row">
    <div class="col-3 col-md-1">
      <div class="square">
        <img loading="lazy" decoding="async" :alt="`${review.user.title} avatar`" class="rounded-circle mb-2 img-fluid"
             :src="review.user.avatar.smUrl" />
      </div>
    </div>
    <div class="col-9 col-md-11 pl-1">
      <div class="row">
        <div class="col-10">
          <p class="m-0">
            <strong>{{ review.user.displayName ?? review.user.title }}</strong>
            <span> - </span>
            <span class="text-muted">{{ createdAt }}</span>
          </p>
        <ReviewStarRating :rating="review.rating" />
        </div>
        <div class="col-2">
          <div class="dropdown float-right">
            <button v-if="ownedByUser" class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            </button>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <button class="dropdown-item btn btn-link btn-sm" @click="editReview">Edit</button>
              <button class="dropdown-item btn btn-link btn-sm" @click="destroyReview">Delete</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-3" v-if="review.body">
    <div class="col-12">
      <p :style="{ 'white-space': 'pre-line' }">{{ review.body }}</p>
    </div>
  </div>
  <div class="row mt-2 mb-2">
    <div class="col-sm-1">
      <ReviewLikeable :likeable="review" likeableType="Review" :user="user" />
    </div>
    <div class="col-sm-5">
      <ReviewRecording :recording="review.publicRecording" v-if="review.publicRecording" />
    </div>
  </div>
  <ReviewPhotos :review="review" />
</div>
</template>

<script>
import moment from 'moment';
import { mapState } from 'vuex';
import ReviewLikeable from './ReviewLikeable.vue';
import ReviewPhotos from './ReviewPhotos.vue';
import ReviewRecording from './ReviewRecording.vue';
import ReviewStarRating from './ReviewStarRating.vue';

export default {
  data() {
    return {
      destroying: false,
    };
  },
  components: {
    ReviewLikeable,
    ReviewPhotos,
    ReviewRecording,
    ReviewStarRating,
  },
  props: {
    review: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState(['user', 'destroyingPhotoIds']),
    createdAt() {
      return moment(this.review.createdAt).fromNow();
    },
    ownedByUser() {
      return this.user && this.user.id === this.review.userId;
    },
  },
  methods: {
    destroyReview() {
      this.$store.dispatch('destroyReview', this.review);
    },
    editReview() {
      this.$store.dispatch('editReview', this.review);
    },
  },
  mounted() {
    if (this.review.checkForPhotos) {
      console.log('check for photos');
    }
  },
};
</script>
